module.exports = __webpack_public_path__ + "img/C07TechWarDogChampion_ua.3035528a.webp";